/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_Restore_RoundInputs */



/**
* | output |
* | --- |
* | "Restore Round" |
*
* @param {Rounds_Restore_RoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_restore_round = /** @type {((inputs?: Rounds_Restore_RoundInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Restore_RoundInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Restaurer la ronde")
	if (locale === "es") return /** @type {LocalizedString} */ ("Restaurar Ronda")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Restaurar Rodada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ripristina Round")
	return /** @type {LocalizedString} */ ("Restore Round")
});